/* prettier-ignore */
/**
 * NOTE:
 *
 * This file is automatically generated by Traduki 2.0.
 * DO NOT CHANGE IT BY HAND or your changes will be lost.
 */
//Vietnamese (Vietnam)
export default {
  'embedded-confluence-common.src.content.empty-state-description': 'Chúng tôi đã tìm khắp nơi nhưng nội dung này không tồn tại. Nội dung này có thể đã bị xóa. Trừ phi có lỗi đánh máy trong URL 😉',
  'embedded-confluence-common.src.content.empty-state-header': 'Chúng tôi không tìm được những gì bạn muốn',
  'embedded.confluence.already-logged-in-paragraph': 'Bạn đã đăng nhập? Hãy thử làm mới.',
  'embedded.confluence.footer.hover.text': 'Xem trong Confluence',
  'embedded.confluence.footer.prefix': 'Được hỗ trợ bởi',
  'embedded.confluence.generic-error-page.login-to-confluence-button': 'Đăng nhập vào Confluence',
  'embedded.confluence.login-page.login-button': 'Đăng nhập vào Confluence',
  'embedded.confluence.login-page.login-button.aria-label': 'Nút Đăng nhập',
  'embedded.confluence.login-page.login-text': 'Bạn cần đăng nhập để xem trang này',
  'embedded.confluence.login-page.refresh-page-banner': 'Sau khi đăng nhập, trang này sẽ tự động làm mới. Nếu không, bạn có thể bấm vào đây để làm mới',
  'embedded.confluence.login-page.refresh-page-banner-refresh-link': 'Làm mới trang',
  'embedded.confluence.need-to-log-in-paragraph': 'Bạn cần đăng nhập để xem trang này',
  'embedded.confluence.still-having-trouble-paragraph': 'Bạn vẫn gặp sự cố? Đảm bảo bạn đã bật các cookie của bên thứ 3 hoặc {link}',
  'embedded.confluence.troubleshooting-link-text': 'tham khảo hướng dẫn khắc phục sự cố này.',
  'embedded.confluence.troubleshooting-link.aria-label': 'liên kết hướng dẫn khắc phục sự cố'
};